import { useState } from "react";
import { AttributeFieldProps } from "./RenderAttributeInput";
import GetAttributeDefinition, { AttributeTargetType, GetWBComponentByTypename } from "../Data/WBData";
import { attributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import React from "react";
import ButtonField from "./ButtonsField";
import { getNodeRootStyleAttributeValue, getNodeStyleAttributeValue, setNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import HeightAndWidthField from "./HeightAndWidthField";
import { RenderScreensizeLabel } from "../Stylebuilder";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import HoverToolTip from "../HoverToolTip";


export default function AnchorField({label,definition,layoutObject,updateFunc,screenSize,saveFunc,siteData}:AttributeFieldProps){


    const positionDef = GetAttributeDefinition(attributeTypes.position);//
   
    const val = getNodeStyleAttributeValue(layoutObject,screenSize,attributeTypes.position);

    const absolute = val == "absolute";
    // const leftDef = GetAttributeDefinition(attributeTypes.left);
    // const rightDef = GetAttributeDefinition(attributeTypes.right);
    // const topDef = GetAttributeDefinition(attributeTypes.top);
    // const bottomDef = GetAttributeDefinition(attributeTypes.bottom);

    const attachType = GetAttributeDefinition("anchorType");

    const calcAnchorType = ()=>{

        const isEmptyOrAuto = (value:string)=>{

            return(value === "" || value === "auto")
         }

     
        let right = getNodeRootStyleAttributeValue(layoutObject,screenSize,attributeTypes.right);
        let bottom = getNodeRootStyleAttributeValue(layoutObject,screenSize,attributeTypes.bottom);




        let topOrBottom = "top";
        let leftOrRight = "left";

        if(!isEmptyOrAuto(bottom)){
            topOrBottom = "bottom";
        }
        if(!isEmptyOrAuto(right)){

            leftOrRight = "right";
        }


   
       return topOrBottom+"-"+leftOrRight;

    }



    const [currentAttachType,setAttatchType] = useState(calcAnchorType());

    const [stateToggle,setStateToggle] = useState(false);



    setNodeComponentAttributeValue(layoutObject,"anchorType",currentAttachType);




    const onAnchorUpdate = ( 
         attribute: string,
        value: string,
        targetType: AttributeTargetType
        )=>{

            //clear all position attributes if we are clearing the anchor
            if(value == "" && attribute == attributeTypes.position){
           

                updateFunc("left","",AttributeTargetType.Style);
                updateFunc("right","",AttributeTargetType.Style);
                updateFunc("top","",AttributeTargetType.Style);
                updateFunc("bottom","",AttributeTargetType.Style);

            }
       
            updateFunc(attribute,value,targetType);
        


            if(attribute === attributeTypes.position){
                if(value === "absolute")
                    setIsAbsolute(true);
                else
                    setIsAbsolute(false);

            }

            setAttatchType(calcAnchorType());
            setStateToggle(!stateToggle);
            setTimeout(()=>{siteData?.designer?.forceUpdate()},10)//update entire designer to force the selected outline to update

    }



    const [isAbsolute,setIsAbsolute] = useState(absolute);
    const hType = (currentAttachType === "top-left"|| currentAttachType === "bottom-left")?"left":"right";
    const vType = (currentAttachType === "bottom-left"|| currentAttachType === "bottom-right")?"bottom":"top";

    const comp = GetWBComponentByTypename(layoutObject.typename);


    const updateAnchorType = (key:string,value:string,target: AttributeTargetType)=>{

        

        if(value.includes("right")){
            
            if(currentAttachType.includes("left")){
                let left = getNodeStyleAttributeValue(layoutObject,screenSize,attributeTypes.left);
                updateFunc("right",left,AttributeTargetType.Style)
            }
            updateFunc("left","auto",AttributeTargetType.Style);
        }
        else if(value.includes("left")){
            if(currentAttachType.includes("right")){
                let right = getNodeStyleAttributeValue(layoutObject,screenSize,attributeTypes.right);
                updateFunc("left",right,AttributeTargetType.Style)
            }


            updateFunc("right","auto",AttributeTargetType.Style);
        }

        if(value.includes("bottom")){
            if(currentAttachType.includes("top")){
                let top = getNodeStyleAttributeValue(layoutObject,screenSize,attributeTypes.top);
                updateFunc("bottom",top,AttributeTargetType.Style)
            }
            updateFunc("top","auto",AttributeTargetType.Style);
        }
        else{
            if(currentAttachType.includes("bottom")){
                let bottom = getNodeStyleAttributeValue(layoutObject,screenSize,attributeTypes.bottom);
                updateFunc("top",bottom,AttributeTargetType.Style)
            }

            
            updateFunc("bottom","auto",AttributeTargetType.Style);
        }
        updateFunc(key,value,target);

        
        let dom = document.getElementById(layoutObject.id);
        if(dom){
            dom.style.zIndex = "1";
        }


        setAttatchType(value);

    }

    const anchorLable = <RenderScreensizeLabel screenSize={ screenSize} label={positionDef.label} ><HoverToolTip text={positionDef.description}/></RenderScreensizeLabel>

    if(layoutObject.typename == wBComponentTypeNames.pageRoot||layoutObject.typename.length<3) //anchor feild is not valid when editing site settings, this is denoted by an empty typename
    return null;
    


    return(
    <>
        <ButtonField label={anchorLable} definition={positionDef}  layoutObject={layoutObject} updateFunc={onAnchorUpdate} screenSize={screenSize} saveFunc={saveFunc} siteData={siteData} />
        { isAbsolute &&  
        <>
        <ButtonField label={attachType.label} key = {currentAttachType} definition={attachType} layoutObject={layoutObject} updateFunc={updateAnchorType} screenSize={screenSize} saveFunc={saveFunc} siteData={siteData} />

        <div className="wb-input-group">
        <RenderScreensizeLabel screenSize={ screenSize} label={"Anchor Offset"} />
       
        <HeightAndWidthField label={hType} domObject={null} screenSize={screenSize} layoutObject={layoutObject} component={comp} updateFunc={onAnchorUpdate} widthAtt={hType} heightAtt={vType} xLabel={hType+":"} yLabel={vType+":"} includeLock = {false} />
        </div>
       </>
       }


    </>
    )

}